import React, { Component } from 'react'

export default class Features extends Component {
    render() {
        const { title, titleColor = false, items } = this.props;
        return (
            <div style={{
                margin: "2.5vh auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <div className="title" style={{color: titleColor}}>{title}</div>
                <div style={{display: "flex", flexDirection: "row", flexFlow: "wrap", justifyContent: "center" }}>
                    {
                        items.map((item, i) => {
                            return <div key={i} style={{margin: "5px 10px", width: "250px"}}>
                                <i className="fas fa-check" style={{color: "#4CAF50"}}></i> {item}
                            </div>;
                        })
                    }
                </div>
            </div>
        )
    }
}
